import dayjs from 'dayjs';

export default function getDatetime(date: string) {
  const datetime = dayjs(date).format('MM/DD/YY HH:mm');

  return datetime;
}
